import * as moment from 'moment';
import qs from 'qs';
import isbot from 'isbot';

import { priceWithCommas } from '../../utils/commonHelper';
import { addNumberDelimiterForPrice } from '../../utils/stringUtil';
import {
  getYadoBackendHost,
  getSearchParams,
  validateSearchParams,
  setMomentLocale,
  countAdults,
  countChildren,
  countRooms,
  existsSearchParams,
  makeRoomName,
  getCancellationLabel,
  makeCancellationValueByType,
  simpleFormat,
  isImageJalanNoPhoto,
  markdownLinkToAHref,
  getTranslatedXNights,
  getBedTypeName,
  getRoomTypeName,
  getTranslatedCancellationNoShow,
  extractRoomIdFromRoomPlanId,
} from '../helper/accommodation_helper';
import ApiClient from './api_client/accommodation_api_client';
import { initCarousel, createTinySliderOptions } from '../../carousel';
import { setPlanIconTexts } from './plan_icon_texts';

let planLoading;

// プラン詳細取得の場合、gonにyadoId（jxxxxxx）とplanIdが必要
export function initAccommodationPlan() {
  disableEnterSubmit();
  setupFormSubmitButton();
  loadPlan();
}

export function initAccommodationPlanModal() {
  const $ = (window as any).jQuery;
  $('#plan_detail_modal').on('show.bs.modal', () => {
    disableBodyScroll();
    updateAccommodationPlanDetail();
  });

  $('#plan_detail_modal').on('hide.bs.modal', () => {
    enableBodyScroll();
    $("#plan_detail_modal .modal-content").animate({ scrollTop: 0 }, 150);
  });
}

function updateAccommodationPlanDetail() {

  showPlanDetailCommonIcons();
  showPlanDetailTableCommonInfo();

  const params = getSearchParams();

  setCheckinCheckoutDate(params);
  setAdultsNumber(params);
  setChildrenNumber(params);
}

function loadPlan() {
  const gon = (window as any).gon;
  const ua = (navigator as any).userAgent;

  const apiClient = new ApiClient({ host: getYadoBackendHost() });
  const searchParams = getSearchParams();

  if (!existsSearchParams(searchParams) || !validateSearchParams(searchParams)) {
    backToAccommodationDetailPage({ resort_code: searchParams.resort_code });
    return;
  }

  setCheckinCheckoutDate(searchParams);
  setNumberOfNights(searchParams);
  setAdultsNumber(searchParams);
  setChildrenNumber(searchParams);
  setRoomNumber(searchParams);

  const yadoId = gon.yadoId;
  const planId = gon.planId;
  if (yadoId != null && planId != null && !isbot(ua)) {
    apiClient.fetchYadoPlanDetail(searchParams, yadoId, planId, onCompletedFetchYadoPlanDetail, onFailedFetchYadoPlanDetail);
  }
}

export function loadPlanModal(roomPlanId, searchParams) {
  const gon = (window as any).gon;
  const ua = (navigator as any).userAgent;

  const apiClient = new ApiClient({ host: getYadoBackendHost() });

  // setNumberOfNights(searchParams);
  // setAdultsNumber(searchParams);
  // setChildrenNumber(searchParams);
  // setRoomNumber(searchParams);

  showLoading();
  hideContents();
  hideErrorMessages();

  const yadoId = gon.yadoId;
  if (!planLoading && yadoId != null && roomPlanId != null && !isbot(ua)) {
    setPlanLoading(true);
    apiClient.fetchYadoPlanDetail(searchParams, yadoId, roomPlanId, onCompletedFetchYadoPlanDetail, onFailedFetchYadoPlanDetail);
  }
}

function onCompletedFetchYadoPlanDetail(data: any) {
  const $ = (window as any).jQuery;

  setPlanLoading(false);

  if (data && data.roomPlan) {
    setupPlanImagesCarousel(data.roomPlan);
    setRoomPlanTitle(data.roomPlan);

    setPlanDescription(data.roomPlan);
    setPlanSpecialNoteForFee(data.roomPlan);
    setPlanDetailPrice(data.roomPlan);
    setGoToBookingButtonLink(data.roomPlan);

    setPlanDetailIcons(data.roomPlan);
    displayDetailTable(data.roomPlan);
    addPlanInfoToSidebox(data.roomPlan);
    setPlanInfoToForm  (data.roomPlan);
    setLastCancellationFreeDateToForm(data.roomPlan);

    setTotalAmountToForm(data.roomPlan);
    setTotalAmountToSidebox(data.roomPlan);
    setTotalAmountToBottom(data.roomPlan);
    setCheckinCheckoutTime(data.roomPlan);
    setCancellationPolicies(data.roomPlan);
    setArrivalTimes(data.roomPlan);
    hideLoading();
    hideErrorMessages();
    showContents();
  }
}

function setTotalAmountToForm(roomPlan) {
  const $ = (window as any).jQuery;
  const tax = roomPlan.plan.totalAmountIncludingTax - roomPlan.plan.totalAmountExcludingTax

  $('#js-plan-total-amount-including-tax').val(roomPlan.plan.totalAmountIncludingTax);
  $('#js-plan-tax').val(tax);
  $('#js-plan-total-amount-excluding-tax').val(roomPlan.plan.totalAmountExcludingTax)
}

function setTotalAmountToSidebox(roomPlan) {
  const $ = (window as any).jQuery;
  const tax = roomPlan.plan.totalAmountIncludingTax - roomPlan.plan.totalAmountExcludingTax
  const exchangeRate = Number($('#current-exchange-rate').val());

  $('#js-accommodation-sidebox-total-amount-excluding-tax').text(priceWithCommas(roomPlan.plan.totalAmountExcludingTax * exchangeRate));
  $('#js-accommodation-sidebox-tax').text(priceWithCommas(tax * exchangeRate));
  $('#js-accommodation-sidebox-total-amount-including-tax').text(priceWithCommas(roomPlan.plan.totalAmountIncludingTax * exchangeRate));

  $('#js-accommodation-sidebox-total-amount-excluding-tax-jpy').text(addNumberDelimiterForPrice(Math.round(roomPlan.plan.totalAmountExcludingTax)));
  $('#js-accommodation-sidebox-tax-jpy').text(addNumberDelimiterForPrice(Math.round(tax)));
  $('#js-accommodation-sidebox-total-amount-including-tax-jpy').text(addNumberDelimiterForPrice(Math.round(roomPlan.plan.totalAmountIncludingTax)));
}

function setTotalAmountToBottom(roomPlan) {
  const $ = (window as any).jQuery;
  const exchangeRate = Number($('#current-exchange-rate').val());

  $('#js-accommodation-submit-area-total-amount-including-tax').text(addNumberDelimiterForPrice(roomPlan.plan.totalAmountIncludingTax));
  $('#js-accommodation-submit-area-total-amount-including-tax-local-price').text(priceWithCommas(roomPlan.plan.totalAmountIncludingTax * exchangeRate));

}

function setupFormSubmitButton() {
  const $ = (window as any).jQuery;
  const form = <HTMLInputElement>document.getElementById('order_form');

  $('#js-accommodation-order-new-visible-submit-button').click(() => {
    disableSubmitButton();
    if (!isValidForm()) {
      enableSubmitButton();
      return;
    }

    updateUrlParameters();

    $('#js-accommodation-order-new-hidden-submit-button').click();
    if (!form.checkValidity()) {
      enableSubmitButton();
      return;
    }
  });
}

function disableSubmitButton() {
  const $ = (window as any).jQuery;

  $.rails.disableElement($('#js-accommodation-order-new-visible-submit-button'));
  $('#js-accommodation-order-new-visible-submit-button').attr('disabled', 'disabled');
}

function enableSubmitButton() {
  const $ = (window as any).jQuery;

  $.rails.enableElement($('#js-accommodation-order-new-visible-submit-button'));
  $('#js-accommodation-order-new-visible-submit-button').removeAttr('disabled');
}

function isValidForm() {

  if (!validatePeopleCountByGender()) {
    return false;
  }

  return true;
}

function validatePeopleCountByGender() {
  const $ = (window as any).jQuery;
  const adults = Number($('.js-data-adults').attr('data-adults'));
  const males = Number($('input[name="rooms[0][males]"]').val());
  const females = Number($('input[name="rooms[0][females]"]').val());

  if (males + females === adults) {
    $('#js-gender-count-error-text').hide();
    return true;
  }
  $('#js-gender-count-error-text').show();
  scrollToGenderInput();
  return false;
}

function scrollToGenderInput() {
  const $ = (window as any).jQuery;

  $('html, body').animate({
    scrollTop: $("#gender-input").offset().top - 100,
  }, 500);
}

function updateUrlParameters() {
  const params = getOrderFormParamsString();
  const lastSegmentOfUrl = location.pathname.substr(location.pathname.lastIndexOf('/') + 1);
  history.replaceState('', '', `${lastSegmentOfUrl}?${params}`);
}

function getOrderFormParamsString() {
  const $ = (window as any).jQuery;

  const form = $('#order_form');
  return form.serialize();
}

function setPlanLoading(isLoading) {
  planLoading = isLoading;
}

function onFailedFetchYadoPlanDetail(status: number, responseJSON: Object) {
  setPlanLoading(false);

  hideContents();
  hideLoading();

  if (status === 404) {
    showNotFoundMessage();
  } else if (status === 429) {
    showTooManyErrorMessage();
  } else {
    showErrorMessage();
  }
}

function disableEnterSubmit() {
  const $ = (window as any).jQuery;

  // テキストフィールドとセレクトでEnterキーを押した時にフォームがsubmitされるのを無効化
  $('input, select').keypress((e) => {
    if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  });

}

function setLastCancellationFreeDateToForm(roomPlan) {
  const $ = (window as any).jQuery;
  const params = getSearchParams();
  const checkinDate = params.checkin_date as string;

  if (roomPlan.plan && roomPlan.plan.cancellationPolicy && roomPlan.plan.cancellationPolicy.policies) {
    const cancellationPolicies = roomPlan.plan.cancellationPolicy.policies;
    const sortedCancellationPolicies = cancellationPolicies.sort((a, b) => {
      if (a.period > b.period) {
        return -1;
      } else {
        return 1;
      }
    });
    const firstPolicyPeriod = sortedCancellationPolicies[0].period;
    const cancellationFreePeriod = firstPolicyPeriod + 1;
    const lastCancellationFreeDate = moment(checkinDate).add(-1 * (cancellationFreePeriod), 'days').format('YYYY-MM-DD');

    $('#js-plan-last-cancellation-free-date').val(lastCancellationFreeDate);
  }
}

function disableBodyScroll() {
  const $ = (window as any).jQuery;
  $('body').css('overflow-y', 'hidden');
}

function enableBodyScroll() {
  const $ = (window as any).jQuery;
  $('body').css('overflow-y', 'visible');
}

function showLoading() {
  const $ = (window as any).jQuery;
  $('.js-show-while-loading').show();
}

function hideLoading() {
  const $ = (window as any).jQuery;
  $('.js-show-while-loading').hide();
}

function showContents() {
  const $ = (window as any).jQuery;
  $('.js-show-when-loaded').show();
}

function hideContents() {
  const $ = (window as any).jQuery;
  $('.js-show-when-loaded').hide();
  $('.js-hide-on-failed').hide();
}

function setupPlanImagesCarousel(roomPlan) {
  const $ = (window as any).jQuery;

  const { room, plan, roomPlanId } = roomPlan;

  if (roomPlan) {
    clearCarouselItem();

    // 部屋画像がじゃらんのno_photo.jpgの場合
    if (room && room.images && isImageJalanNoPhoto(room.images[0])) {
      const roomId = extractRoomIdFromRoomPlanId(roomPlanId);
      if ($(`#js-room-${roomId}`).length === 1) {
        const firstRoomImage = $(`#js-room-${roomId}`).attr('data-room-first-image');
        appendCarouselItem(firstRoomImage);
      }
    } else if (room && room.images && room.images.length >= 1) { // 部屋画像が正常にある場合
      room.images.forEach((image) => {
        appendCarouselItem(image)
      });
    }
    if (plan.images && plan.images.length >= 1) {
      plan.images.forEach((image) => {
        appendCarouselItem(image);
      });
    }
    if ($('#accommodation-plan-images').length === 0) return;
    const options = createTinySliderOptions('#accommodation-plan-images');
    options.nav = false;
    options.loop = false;
    options.touch = false;
    options.mouseDrag = false;
    delete options.responsive['576'];
    options.responsive['992'].items = 2;
    options.responsive['1200'].items = 2;
    initCarousel(options);
    hidePrevNextButtonIfLessThanEqual2(roomPlan);
  }
}

function hideErrorMessages() {
  hideNotFoundMessage();
  hideTooManyErrorMessage();
  hideErrorMessage();
}

function showNotFoundMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-not-found-plan').show();
}

function hideNotFoundMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-not-found-plan').hide();
}

function showTooManyErrorMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-too-many-error-occurred-plan').show();
}

function hideTooManyErrorMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-too-many-error-occurred-plan').hide();
}

function showErrorMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-error-occurred-plan').show();
}

function hideErrorMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-error-occurred-plan').hide();
}

function setPlanDetailIcons(roomPlan): void {
  const $ = (window as any).jQuery;

  const planDetailIconsElem = $('#js-plan-detail-icons');
  if (roomPlan.room) {
    if (roomPlan.room.smoking) {
      planDetailIconsElem.find('.js-plan-smoke').show();
    }
    if (roomPlan.room.smoking === false) {
      planDetailIconsElem.find('.js-plan-non-smoke').show();
    }
  }
  if (roomPlan.plan) {
    if (roomPlan.plan.breakfast) {
      planDetailIconsElem.find('.js-plan-meal').show();
    }

    if (roomPlan.plan.dinner) {
      planDetailIconsElem.find('.js-plan-meal').show();
    }
  }
}

function showPlanDetailCommonIcons() {
  const $ = (window as any).jQuery;
  const gon = (window as any).gon;

  const planDetailIconsElem = $('#js-plan-detail-icons');
  if (gon.yado) {
    if (gon.yado.roomFacility.bath) {
      planDetailIconsElem.find('.js-plan-bath').show();
    }
    if (gon.yado.roomFacility.airConditioner) {
      planDetailIconsElem.find('.js-plan-air-conditioner').show();
    }
  }
}

function showPlanDetailTableCommonInfo() {
  const $ = (window as any).jQuery;
  const gon = (window as any).gon;
  if (gon.yado) {
    if (gon.yado.roomFacility) {
      if (gon.yado.roomFacility.freeWifi) {
        $('.js-plan-internet-row').show();
      } else {
        $('.js-plan-internet-row').hide();
      }
    }
  }
}

function addPlanInfoToSidebox(roomPlan): void {
  const $ = (window as any).jQuery;

  const {room, plan} = roomPlan;

  if ($('#js-plan-sidebox').length === 0) return;

  const sideboxElem = $('#js-plan-sidebox');

  if (plan.checkinTime && plan.checkinTime.from) {
    sideboxElem.find('.js-plan-checkin-time-from').text(getTranslatedCheckinFromTime(plan.checkinTime.from));
  }
  if (plan.checkoutTime && plan.checkoutTime.to) {
    sideboxElem.find('.js-plan-checkout-time-to').text(getTranslatedCheckoutToTime(plan.checkoutTime.to));
  }

  // 部屋タイプ
  if (room.type) {
    sideboxElem.find('.js-room-type').text(getRoomTypeName(room.type));
  }

  // ベッドタイプ
  if (room.bedType) {
    sideboxElem.find('.js-room-bed').show();
    sideboxElem.find('.js-room-main-bed-multiply').show();

    switch (room.bedType) {
      case 'single': {
        sideboxElem.find('.js-room-bed-single').show();
        break;
      }
      case 'double': {
        sideboxElem.find('.js-room-bed-double').show();
        break;
      }
      case 'semi_double': {
        sideboxElem.find('.js-room-bed-semi-double').show();
        break;
      }
      case 'queen': {
        sideboxElem.find('.js-room-bed-queen').show();
        break;
      }
      case 'king': {
        sideboxElem.find('.js-room-bed-king').show();
        break;
      }
      case 'futon': {
        sideboxElem.find('.js-room-bed-futon').show();
        break;
      }
      default:
        break;
    }
  }

  // ベッド数
  if (room.numberOfBeds) {
    sideboxElem.find('.js-room-main-bed-count').text(room.numberOfBeds);
    sideboxElem.find('.js-room-main-bed-count').show();
  }

  // エクストラベッド
  if (room.numberOfExtraBeds) {
    sideboxElem.find('.js-room-bed-delimiter').show();
    sideboxElem.find('.js-room-bed-extra').show();
    sideboxElem.find('.js-room-extra-bed-multiply').show();
    sideboxElem.find('.js-room-extra-bed-count').text(room.numberOfExtraBeds);
    sideboxElem.find('.js-room-extra-bed-count').show();
  }

  // 食事
  if (plan.breakfast) {
    sideboxElem.find('.js-plan-breakfast').show();
  } else {
    sideboxElem.find('.js-plan-breakfast').hide();
  }
  if (plan.breakfast && plan.dinner) {
    sideboxElem.find('.js-plan-meal-delimiter').show();
  } else {
    sideboxElem.find('.js-plan-meal-delimiter').hide();
  }
  if (plan.dinner) {
    sideboxElem.find('.js-plan-dinner').show();
  } else {
    sideboxElem.find('.js-plan-dinner').hide();
  }
  if (!plan.breakfast && !plan.dinner) {
    sideboxElem.find('.js-plan-no-meal').show();
  } else {
    sideboxElem.find('.js-plan-no-meal').hide();
  }
}

function setPlanInfoToForm  (roomPlan): void {
  const $ = (window as any).jQuery;
  const { plan, room } = roomPlan;

  $('#js-plan-breakfast-hidden-field').val(plan.breakfast);
  $('#js-plan-dinner-hidden-field').val(plan.dinner);
  $('#js-room-bed-type-hidden-field').val(room.bedType);
  $('#js-room-number-of-beds-hidden-field').val(room.numberOfBeds);
  $('#js-room-number-of-extra-beds-hidden-field').val(room.numberOfExtraBeds);
  $('#js-plan-checkin-time-from-hidden-field').val(plan.checkinTime.from);
  $('#js-plan-checkout-time-to-hidden-field').val(plan.checkoutTime.to);
  $('#js-room-type').val(room.type);
}

function setCheckinCheckoutDate(searchParams): void {
  const $ = (window as any).jQuery;

  const planDetailTableElem = $('#js-plan-detail-table');

  setMomentLocale();
  if (searchParams) {
    if (searchParams.checkin_date) {
      const translatedCheckinDate = moment(searchParams.checkin_date).format('LL');
      planDetailTableElem.find('.js-checkin-date').text(translatedCheckinDate);
    }
    if (searchParams.checkout_date) {
      const translatedCheckoutDate = moment(searchParams.checkout_date).format('LL');
      planDetailTableElem.find('.js-checkout-date').text(translatedCheckoutDate);
    }
  }
}

function setNumberOfNights(searchParams): void {
  const $ = (window as any).jQuery;

  if (searchParams) {
    if (searchParams.checkin_date && searchParams.checkout_date) {
      const checkinDate = moment(searchParams.checkin_date)
      const checkoutDate = moment(searchParams.checkout_date)
      const numberOfNights = checkoutDate.diff(checkinDate, 'days');
      const translatedNumberOfNights = getTranslatedXNights(numberOfNights);
      $('.js-number-of-nights').text(translatedNumberOfNights);
    }
  }
}

function setAdultsNumber(searchParams): void {
  const $ = (window as any).jQuery;

  const planDetailTableElem = $('#js-plan-detail-table');

  if (searchParams && searchParams.rooms) {
    const adultsNumber = countAdults(searchParams.rooms);
    planDetailTableElem.find('.js-adults-number').text(adultsNumber);
  }
}

function setChildrenNumber(searchParams): void {
  const $ = (window as any).jQuery;

  const planDetailTableElem = $('#js-plan-detail-table');

  if (searchParams && searchParams.rooms) {
    const childrenNumber = countChildren(searchParams.rooms);

    if (childrenNumber >= 1) {
      planDetailTableElem.find('.js-children-container').removeClass('d-none');
      planDetailTableElem.find('.js-children-number').text(childrenNumber);
    } else {
      planDetailTableElem.find('.js-children-container').addClass('d-none');
    }
  }
}

function setRoomNumber(searchParams): void {
  const $ = (window as any).jQuery;
  
  if (searchParams && searchParams.rooms) {
    const roomsNumber = countRooms(searchParams.rooms);
    $('.js-rooms-number').text(roomsNumber);
  }
}

function setRoomPlanTitle(roomPlan): void {
  const $ = (window as any).jQuery;

  const planTitle = roomPlan.plan.name;
  const roomTitle = makeRoomName(roomPlan.room);

  $('.js-room-plan-main-title').text(planTitle || roomTitle);
  $('.js-room-plan-sub-title').text(roomTitle);

  // じゃらんの場合は部屋名のみでプラン名がないため、サブタイトル非表示
  if (!planTitle) {
    $('.js-room-plan-sub-title').hide();
  } else {
    $('.js-room-plan-sub-title').show();
  }
}

function setPlanDescription({ plan }): void {
  const $ = (window as any).jQuery;

  const { description } = plan;
  if (description) {
    $('#js-plan-description').html(simpleFormat(markdownLinkToAHref(description)));
    $('#js-plan-description').show();
  } else {
    $('#js-plan-description').hide();
  }
}

function setPlanDetailPrice(roomPlan): void {
  const $ = (window as any).jQuery;
  const { plan } = roomPlan;
  const exchangeRate = Number($('#current-exchange-rate').val());

  $('#js-plan-detail-price').text(priceWithCommas(plan.totalAmountExcludingTax * exchangeRate));
  $('#js-plan-detail-price-jpy').text(addNumberDelimiterForPrice(Math.round(plan.totalAmountExcludingTax)));

  $('#js-plan-detail-tax-included-price').text(priceWithCommas(plan.totalAmountIncludingTax * exchangeRate));
  $('#js-plan-detail-tax-included-price-jpy').text(addNumberDelimiterForPrice(Math.round(plan.totalAmountIncludingTax )));
}

function setPlanSpecialNoteForFee({ plan }): void {
  const $ = (window as any).jQuery;

  const { specialNoteForFee } = plan;
  if (specialNoteForFee) {
    $('#js-plan-special-note-for-fee-label').show();
    $('#js-plan-special-note-for-fee').html(simpleFormat(specialNoteForFee));
    $('#js-plan-special-note-for-fee').show();
  } else {
    $('#js-plan-special-note-for-fee-label').hide();
    $('#js-plan-special-note-for-fee').hide();
  }
}

function setTotalAmount(roomPlan): void {
  const $ = (window as any).jQuery;
  const { plan } = roomPlan;

  if (typeof plan.totalAmountIncludingTax === 'number' && typeof plan.totalAmountExcludingTax === 'number') {
    const tax = plan.totalAmountIncludingTax - plan.totalAmountExcludingTax;
    $('.js-total-amount-excluding-tax').text(addNumberDelimiterForPrice(plan.totalAmountExcludingTax));
    $('.js-total-amount-including-tax').text(addNumberDelimiterForPrice(plan.totalAmountIncludingTax));
    $('.js-total-amount-tax').text(addNumberDelimiterForPrice(tax));

    // 予約用の Hidden field にセット
    $('input[name="total_amount_including_tax"]').val(plan.totalAmountIncludingTax);
  }
}

function setCheckinCheckoutTime(roomPlan): void {
  const $ = (window as any).jQuery;
  const { plan } = roomPlan;
  
  const planDetailTableElem = $('#js-plan-detail-table');

  let checkinTimeStr = '';
  let checkoutTimeStr = '';
  if (plan.checkinTime) {
    if (plan.checkinTime.from && plan.checkinTime.to) {
      checkinTimeStr = `${plan.checkinTime.from}-${plan.checkinTime.to}`;
    } else {
      if (plan.checkinTime.from) {
        checkinTimeStr = getTranslatedCheckinFromTime(plan.checkinTime.from);
      }
    }
  }
  if (plan.checkoutTime && plan.checkoutTime.to ) {
    checkoutTimeStr = getTranslatedCheckoutToTime(plan.checkoutTime.to);
  }

  planDetailTableElem.find('.js-checkin-time').text(checkinTimeStr);
  planDetailTableElem.find('.js-checkout-time').text(checkoutTimeStr);
}

function setArrivalTimes(roomPlan): void {
  const $ = (window as any).jQuery;
  const { plan } = roomPlan;

  if (plan.checkinTime) {
    const arrivalTimes = generateArrivalTimes(plan.checkinTime);
    const optionElems = arrivalTimes.map((time) => {
      const optionElem = $('<option>', { value: time, text: time });
      return optionElem;
    });

    $('#js-select-arrival-time').append(optionElems);

    const params = getSearchParams();
    if (params.checkin_time !== undefined) {
      $('#js-select-arrival-time').val(params.checkin_time);
    }

    $('.js-checkin-from-to-display').text(`${plan.checkinTime.from} - ${plan.checkinTime.to}`);
  }
}

function setCancellationPolicies(roomPlan): void {
  const $ = (window as any).jQuery;
  const { plan } = roomPlan;


  let containerElem;
  let createPolicyRow;

  if ($('#js-cancellation-policies-plan-detail').length === 1) {
    containerElem = $('#js-cancellation-policies-plan-detail');
    createPolicyRow = (label, humanReadableValue) => `
      <ul>
        <li class="sy_cancel_policy_left">${label}</li>
        <li class="sy_cancel_policy_right">${humanReadableValue}</li>
      </ul>
    `
  } else if ($('#js-cancellation-policies-plan-booking').length === 1) {
    containerElem = $('#js-cancellation-policies-plan-booking');
    createPolicyRow = (label, humanReadableValue) => `
      <div class="linewrapper">
        <div class="sy_booking_line_label">${label}</div>
        <div class="middle" /><div class="sy_booking_line_value">${humanReadableValue}</div>
      </div>
    `
  } else {
    return;
  }


  containerElem.empty();
  if (plan && plan.cancellationPolicy && plan.cancellationPolicy.policies && plan.cancellationPolicy.type) {
    plan.cancellationPolicy.policies.forEach(({period, value}: {period: number, value: number}) => {
      const label = getCancellationLabel(period);
      const humanReadableValue = makeCancellationValueByType(value, plan.cancellationPolicy.type);
      if (label != '') {
        const policyRow = createPolicyRow(label, humanReadableValue);
        containerElem.append(policyRow);
      }
    });
    // 最終行にno-show: 100%を追加
    const policyRow = createPolicyRow(getTranslatedCancellationNoShow(), '100%');
    containerElem.append(policyRow);
  }
}

function appendCarouselItem(imageUrl: string): void {
  const $ = (window as any).jQuery;

  let itemElem = $('#js-plan-images').find('.js-carousel-item-template').first().clone();
  itemElem.addClass('js-carousel-item').show();
  itemElem.appendTo($('#js-plan-images').find('.js-carousel'));
  const itemImageInnerElem = itemElem.find('.js-carousel-item__image-inner');
  itemImageInnerElem.css('background-image', `url(${imageUrl})`);
}

function clearCarouselItem(): void {
  const $ = (window as any).jQuery;
  $('#js-plan-images').empty();
  $('#js-plan-images-template').clone().children().appendTo($('#js-plan-images'));
}

function hidePrevNextButtonIfLessThanEqual2(roomPlan): void {
  const $ = (window as any).jQuery;

  if (roomPlan && roomPlan.room && roomPlan.room.images && roomPlan.plan && roomPlan.plan.images) {
    const imageCount = roomPlan.room.images.length + roomPlan.plan.images.length;
    if (imageCount <= 2) {
      $('.tns-controls').remove();
    }
  }
}

function setGoToBookingButtonLink(roomPlan) {
  const $ = (window as any).jQuery;
  const searchParams = getSearchParams();

  const buttonElem = $('#js-plan-detail-book-button');
  
  buttonElem.attr('href', `${location.pathname}/plans/${roomPlan.roomPlanId}/order/new?${$.param(searchParams)}`)
}

function displayDetailTable(roomPlan) {
  const $ = (window as any).jQuery;

  const { room, plan } = roomPlan;

  if ($('#js-plan-detail-table').length === 0) return;

  const planDetailTableElem = $('#js-plan-detail-table');

  // 食事
  if (plan.breakfast) {
    planDetailTableElem.find('.js-plan-breakfast').removeClass('d-none');
  } else {
    planDetailTableElem.find('.js-plan-breakfast').addClass('d-none');
  }
  if (plan.breakfast && plan.dinner) {
    planDetailTableElem.find('.js-plan-meal-delimiter').removeClass('d-none');
  } else {
    planDetailTableElem.find('.js-plan-meal-delimiter').addClass('d-none');
  }
  if (plan.dinner) {
    planDetailTableElem.find('.js-plan-dinner').removeClass('d-none');
  } else {
    planDetailTableElem.find('.js-plan-dinner').addClass('d-none');
  }
  if (!plan.breakfast && !plan.dinner) {
    planDetailTableElem.find('.js-plan-no-meal').removeClass('d-none');
  } else {
    planDetailTableElem.find('.js-plan-no-meal').addClass('d-none');
  }

  // ベッド
  if (room.bedType && room.numberOfBeds) {
    planDetailTableElem.find('.js-plan-bed').text(getBedTypeName(room.bedType) + ' x ' + room.numberOfBeds)
    planDetailTableElem.find('.js-plan-bed-row').show();
    if (room.numberOfExtraBeds) {
      planDetailTableElem.find('.js-plan-bed-delimiter').removeClass('d-none');
      planDetailTableElem.find('.js-plan-extra-bed').text(getBedTypeName('extra') + ' x ' + room.numberOfExtraBeds)
      planDetailTableElem.find('.js-plan-extra-bed').removeClass('d-none');
    } else {
      planDetailTableElem.find('.js-plan-bed-delimiter').addClass('d-none');
      planDetailTableElem.find('.js-plan-extra-bed').addClass('d-none');
    }
  } else {
    planDetailTableElem.find('.js-plan-bed-row').hide();
  }

  // 喫煙可否
  if (room.smoking) {
    planDetailTableElem.find('.js-plan-smoking').removeClass('d-none');
  } else {
    planDetailTableElem.find('.js-plan-smoking').addClass('d-none');
  }
  if (room.smoking === false) {
    planDetailTableElem.find('.js-plan-non-smoking').removeClass('d-none');
  } else {
    planDetailTableElem.find('.js-plan-non-smoking').addClass('d-none');
  }
  if (room.smoking == null) {
    planDetailTableElem.find('.js-plan-unknown-smoking').removeClass('d-none');
  } else {
    planDetailTableElem.find('.js-plan-unknown-smoking').addClass('d-none');
  }
}

function backToAccommodationDetailPage(params = null) {
  if (params) {
    location.href = `./..?${qs.stringify(params)}`;
  } else {
    location.href = './..'
  }
}

function generateArrivalTimes(checkinTime: { from?: string, to?: string }): Array<string> {
  const FROM_DEFAULT = '15:00';
  const TO_DEFAULT = '19:00';

  const fromTime = checkinTime.from || FROM_DEFAULT;
  const toTime = checkinTime.to || TO_DEFAULT;

  const fromHour = fromTime.split(':')[0];
  const toHour = toTime.split(':')[0];

  let generationHoursCount = Number(toHour) - Number(fromHour);

  if (generationHoursCount <= -1) {
    // ありえない状態だが、エラーを避けるために仮の正の数にする
    generationHoursCount = 3;
  }

  // fromが16時、toが22時の場合、17, 18, 19, 20, 21, 22 を生成する
  const generationHours = Array.from(new Array(generationHoursCount)).map((v, i) => i + 1 + Number(fromHour))
  const generationTimes = generationHours.map((hour, i) => `${hour}:00`)

  const resultTimes = [
    fromTime, // fromTimeは実際のものを使用する（16:30等、分が00でない場合を考慮）
    ...generationTimes,
  ];

  return resultTimes;
}

function getTranslatedCheckinFromTime(time: string) {
  const $ = (window as any).jQuery;
  const translatedCheckinFromTime = $('#t-checkin-from-time').attr('data-t-checkin-from-time');
  return translatedCheckinFromTime.replace('%time', time);
}

function getTranslatedCheckoutToTime(time: string) {
  const $ = (window as any).jQuery;
  const translatedCheckoutToTime = $('#t-checkout-to-time').attr('data-t-checkout-to-time');
  return translatedCheckoutToTime.replace('%time', time);
}
